import { Component, inject, OnInit, forwardRef } from "@angular/core";
import { AuthModule } from "../../../auth.module";
import { TranslateModule } from "@ngx-translate/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { AuthService } from "../../../services/auth.service";
import { AuthState } from "../../../models/auth.model";
import { DialogRef } from "@angular/cdk/dialog";
import { SharedModule } from "src/shared/shared.module";
import { CommonModule } from "@angular/common";
import { BRAND } from "src/app/config/brand.config";
import { BrandLogoComponent } from "src/shared/brand-logo/brand-logo.component";

@Component({
  selector: "app-login-dialog",
  imports: [
    AuthModule,
    TranslateModule,
    MatDialogModule,
    forwardRef(() => SharedModule),
    CommonModule,
    BrandLogoComponent,
  ],
  templateUrl: "./login-dialog.component.html",
  styleUrl: "./login-dialog.component.scss",
})
export class LoginDialogComponent implements OnInit {
  #dialogRef = inject(DialogRef<LoginDialogComponent>);
  #authService = inject(AuthService);

  readonly brand = BRAND;
  authState = this.#authService.authState;
  AuthStates = AuthState;

  ngOnInit(): void { }
  onClose() {
    this.#authService.updateAuthState(AuthState.UNAUTHORIZED);
    this.#dialogRef.close();
  }

  backToSignIn() {
    this.#authService.updateAuthState(AuthState.UNAUTHORIZED);
  }
}
